import { AppState } from '../reducer';
import { createSelector } from '@ngrx/store';

export const selectCounterState = (state: AppState) => state.commons;
export const getCommon = createSelector(
  selectCounterState,
  commons => commons,
);
